import React from 'react';
import FamilyHeader from './FamilyHeader';
import LinkedItems from './LinkedItems';
import ActivityFeed from './ActivityFeed';

/**
 * FamilyView component (Stats View)
 * Right pane displaying family statistics, linked items, and activity feed
 */
export default function FamilyView({
    selectedFamily,
    activeProjectName,
    familyRulesets,
    familyFeatures,
    familyProjects,
    latestChanges,
    activitySortBy,
    activitySortOrder,
    onExportFamily,
    onEditFamily,
    onShareFamily,
    onDeleteFamily,
    onActivitySortByChange,
    onActivitySortOrderToggle,
    onViewChangeDetails,
    onRevertMapping,
    onSelectProject,
    onSelectFeature,
    onSelectRuleset,
    activeProjectId,
    onUnshareFamily,
    onUnlinkFamily,
    onLinkToActive
}) {
    return (
        <div style={{ flex: 1, minHeight: 0, height: '100%', overflow: 'hidden', padding: '2rem', display: 'flex', flexDirection: 'column' }} className="fade-in">
            <div style={{ width: '100%', maxWidth: '100%', display: 'flex', flexDirection: 'column', gap: 0, flex: 1, minHeight: 0, overflow: 'hidden' }}>
                <div style={{ flexShrink: 0 }}>
                    <FamilyHeader
                        selectedFamily={selectedFamily}
                        activeProjectName={activeProjectName}
                        onExportFamily={onExportFamily}
                        onEditFamily={onEditFamily}
                        onShareFamily={onShareFamily}
                        onDeleteFamily={onDeleteFamily}
                    />
                </div>
                
                {/* Detail Columns (Two Column Split) */}
                <div style={{ display: 'grid', gridTemplateColumns: '1.2fr 1fr', gap: '1rem', flex: 1, minHeight: 0, overflow: 'hidden' }}>
                    {/* Left Column: Linked Items */}
                    <LinkedItems
                        family={selectedFamily}
                        familyProjects={familyProjects}
                        familyRulesets={familyRulesets}
                        familyFeatures={familyFeatures}
                        activeProjectId={activeProjectId}
                        onSelectProject={onSelectProject}
                        onSelectFeature={onSelectFeature}
                        onSelectRuleset={onSelectRuleset}
                        onShareFamily={onShareFamily}
                        onUnshareFamily={onUnshareFamily}
                        onUnlinkFamily={onUnlinkFamily}
                        onLinkToActive={onLinkToActive}
                    />
                    
                    {/* Right Column: Activity Feed */}
                    <div style={{ minHeight: '100%', height: 0, display: 'flex', flexDirection: 'column' }}>
                        <ActivityFeed
                            latestChanges={latestChanges}
                            activitySortBy={activitySortBy}
                            activitySortOrder={activitySortOrder}
                            onSortByChange={onActivitySortByChange}
                            onSortOrderToggle={onActivitySortOrderToggle}
                            onViewChangeDetails={onViewChangeDetails}
                            onRevertMapping={onRevertMapping}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export { FamilyHeader, LinkedItems, ActivityFeed };
